import { SettingLanguagesContainer } from 'src/containers';

export const SettingLanguages = () => <SettingLanguagesContainer />;
